import { DefaultOptions, QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
            networkMode: "offlineFirst",
        },
        mutations: {
            networkMode: "offlineFirst",
        },
    } as DefaultOptions,
});

export { queryClient };
export { QueryClientProvider } from "@tanstack/react-query";
